module.exports = {
    baseUrl: process.env.VUE_APP_BASE_API, //开发环境用到的baseurl
    hideloading: true
}